<template>
    <v-row class="row--xx-small">
        <v-col v-if="!withoutKeys" cols="12" md="auto">
            <v-select v-model="query.searchKey" :items="searchKeys" :class="`human-resource-search-key-${className}`" :menuProps="{ attach: `.human-resource-search-key-${className}` }" v-bind="attrs_input" class="v-input--small w-md-120px" />
        </v-col>
        <v-col cols="12" md="auto">
            <v-text-field v-model="query.searchValue" v-bind="attrs_input" class="v-input--small v-text-field--search w-md-240px" @keydown.enter="emit">
                <template #prepend-inner>
                    <v-btn icon text @click="emit"><i class="icon icon-search-black"></i></v-btn>
                </template>
            </v-text-field>            
        </v-col>
        <v-col cols="12" md="auto">
            <human-resource-sort class="v-input--small w-md-120px" />
        </v-col>
    </v-row>
    <!-- <v-text-field v-model="query.searchValue" v-bind="attrs_input" append-icon="mdi-magnify" class="w-480px" @click:append="emit" @keydown.enter="emit">
        <template #prepend v-if="!withoutKeys">
            <v-select v-model="query.searchKey" :items="searchKeys" :class="`human-resource-search-key-${className}`" :menuProps="{ attach: `.human-resource-search-key-${className}` }" v-bind="attrs_input" class="w-120px" />
        </template>
        <template #append-outer> <human-resource-sort class="w-120px" /> </template>
    </v-text-field> -->
</template>

<script>
import { attrs_input } from "@/assets/variables";

import HumanResourceSort from "./human-resource-sort.vue";

const initQuery = (query = {}) => ({
    ...query,

    ["searchKey"]: query["searchKey"] || null,
    ["searchValue"]: query["searchValue"] || null,
});

const searchKeys = [
    { value: null, text: "전체" },
    { value: "resume.personalInformation.name", text: "이름" },
    { value: "resume.hashTags", text: "해시태그" },
];

export default {
    components: {
        HumanResourceSort,
    },
    props: {
        withoutKeys: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        searchKeys,
        attrs_input,
        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            const { ...query } = this.query;

            if (!query["searchKey"]) delete query["searchKey"];
            if (!query["searchValue"]) delete query["searchValue"];

            delete query["page"];

            this.$router.push({ query });
        },
    },
};
</script>


<style lang="scss" scoped>
.row--x-small{
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
</style>